/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import {useCallback, useState} from 'react';

/**
 * Provides a utility hook for interractivity of Tracking filters search with animation.
 *
 * ```typescript
 *
 *   import {useAutocompleteSearch} from '@ion/dls/src/hooks/';
 *   const {
 *       openSearch,
 *       closeSearch,
 *       openFilterSearch
 *   } = useAutocompleteSearch();
 *
 * ```
 */
export const useAutocompleteSearch = () => {
  const [openFilterSearch, setOpenFilterSearch] = useState(false);

  const openSearch = useCallback(() => {
    setOpenFilterSearch(true);
  }, []);

  const closeSearch = useCallback(() => {
    setOpenFilterSearch(false);
  }, []);

  return {
    openSearch,
    closeSearch,
    openFilterSearch
  };
};
